import { process } from '@progress/kendo-data-query';
import { Button, DropDownButton } from '@progress/kendo-react-buttons';
import { PagerTargetEvent } from '@progress/kendo-react-data-tools';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import {
  Grid,
  GridCellProps,
  GridColumn,
  GridColumnMenuCheckboxFilter,
  GridColumnMenuFilter,
  GridColumnMenuGroup,
  GridColumnMenuProps,
  GridColumnMenuSort,
  GridPageChangeEvent,
  GridToolbar,
} from '@progress/kendo-react-grid';
import { TabStrip, TabStripSelectEventArguments, TabStripTab } from '@progress/kendo-react-layout';
import { GridPDFExport, PDFExport } from "@progress/kendo-react-pdf";
import clsx from 'clsx';
import { format } from 'date-fns';
import React, {
  Dispatch,
  MouseEvent as ReactMouseEvent,
  SetStateAction,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import { CSVLink } from 'react-csv';
import SessionStorageService from '../../services/SessionStorageService';
import { GetUserNameTecnico, b64toBlob, clearEntidade, exportPDFWithMethod, fillLocation, get, handleDownload, handleGenericError, hasPermission, post, setEntidadeSelected, updateColumnsGrid, useCombos } from '../../services/utils';
import { useCommonStore } from '../../stores/common';
import { useEntidadeStore } from '../../stores/entidade';
import commonStyles from '../../styles/common/Common.module.scss';
import styles from '../../styles/entidade/ResultadoEntidadeForm.module.scss';
import { AUTH_LOCALSTORAGE, CONSULTAR_ENTIDADES, CRITERIO_JURISDICAO, CRITERIO_SEDE, CURRENT_TIMEZONE, ENTIDADE_POINT_NAME, GET_DOCUMENTO, GET_ENTIDADE, GET_ENTIDADE_JURISDICAO_BY_ENTIDADE, GET_ENTIDADE_SHAPEFILE, GET_LIST_RESULTS_DI_ENTIDADE, GET_USER_BY_ID, PERMISSION_ENTIDADES_PERFIL_COMPLETO_EDICAO, PERMISSION_ENTIDADES_PERFIL_COMPLETO_LEITURA, PERMISSION_ENTIDADES_PERFIL_TOTAL, PESQUISAR_DOCUMENTOS_BY_ENTIDADES, RELATORIO_MERGE_ENTIDADE, URL_AJUDA_ENTIDADES, URL_FONT_GRID_PDF, clearLayers } from '../../utils/constants';
import MaximizeButton from '../common/MaximizeButton';
import CustomGridCell from '../ocorrencia/CustomGridCell';
import { ResultadoEntidadeCommandGridCell } from './ResultadoEntidadeCommandGridCell';
import useClearMap from '../../hooks/useClearMap';
import { ResultadoDocumentoCommandGridCell } from '../documentos/ResultadoDocumentoCommandGridCell';
import { Dialog } from '@progress/kendo-react-dialogs';
import ImagePreviewV2 from '../viewer/ImagePreviewV2';
import VisualizadorColunas from '../Generico/VisualizadorColunas ';
import useVisibleColumns, { Key } from '../../hooks/useVIsibleColumns';
import { elementoClickMais, itemRenderMais, mostraFloatingMenu_e_Mapa, ocultaFloatingMenu_e_Mapa, telaMobile } from '../common/ItemRenderMais';
import ReactGA from 'react-ga4';
import { drawDOM, exportPDF } from "@progress/kendo-drawing";
import { defineFont } from '@progress/kendo-drawing/pdf';
import moment from 'moment'
import "moment-timezone"
import { base64ApaImage, base64FooterImages, base64SiarlImage } from '../../routes/Base64Images';

type Props = {
  onCloseClick: (
    e: ReactMouseEvent<HTMLButtonElement, MouseEvent>
  ) => void | undefined
  setShowResults: Dispatch<SetStateAction<boolean>>
  setShowEntidadeForm?: Dispatch<SetStateAction<boolean>>
}

type PageState = {
  skip: number
  take: number
}


const initialDataState: PageState = { skip: 0, take: 20 }
const keyPainelPrincipal:Key = 'entidadeColunasVisiveis';
const keyPainelDocumentos:Key = 'entidadeDocumentosColunasVisiveis';

export default function ResultadoEntidadeForm({
  onCloseClick,
  setShowResults,
  setShowEntidadeForm,
}: Props) {
  const [isMobile, setIsMobile] = useState(false);
  const [page, setPage] = useState<PageState>(initialDataState)
  const [paginacao, setPaginacao] = useState<PageState>(initialDataState)
  const [pageSizeValue, setPageSizeValue] = useState<
    number | string | undefined
  >()
  const [entidades, setEntidades] = useState([])
  const selectEntidadeResult = useEntidadeStore(
    (state) => state.selectEntidadeResult
  )

  const [urlDoDocumento, setUrlDoDocumento] = useState("");
  const [idDoDocumento, setIdDoDocumento] = useState("");
  const [openForm, setOpenForm] = useState<boolean>(false)
  const isCurrentViewMaximized = useCommonStore(state => state.isCurrentViewMaximized)
  const restoreView = useCommonStore(state => state.restoreView)
  const {getVisibleColumns, removeColumnsKeys} = useVisibleColumns();
  const[entidadesFinal, setEntidadesFinal] = useState<any[]>([]);
  const [pageble, setPageble] = useState<any>({
    buttonCount: 5,
    info: true,
    type: 'numeric',
    pageSizes: true,
    previousNext: true,
  })

  const relatorioEntidadeMerge = async (data: any) =>
    await post<any, any>(`${RELATORIO_MERGE_ENTIDADE}`, data)

  const getEntidadesPorIds = async (data: any) =>
    await post<any, any>(`${GET_LIST_RESULTS_DI_ENTIDADE}`, data)

  const getEntidade = async (data: any) =>
    await get<any, any>(`${GET_ENTIDADE}/` + data)

    const consultarEntidades = async (data: any) =>
    await post<any, any>(`${CONSULTAR_ENTIDADES}`, data)

    const getEntidadeJuridicao = async (data: any) => 
    await get<any,any>(GET_ENTIDADE_JURISDICAO_BY_ENTIDADE + "/" + data);

   const getShapeFile = async (data: any) => await post<any, any>(GET_ENTIDADE_SHAPEFILE, data);

  const getDocumento = async (data: any) =>
    await get<any, any>(`${GET_DOCUMENTO}/` + data)
  
  const getUserById = async (data: any) =>
  await get<any, any>(`${GET_USER_BY_ID}/` + data)

  const getDocumentosByEntidades = async (data: any) =>
    await post<any, any>(`${PESQUISAR_DOCUMENTOS_BY_ENTIDADES}`, data)

  const initialized = useRef(false)
  useEffect(() => {
      if (!initialized.current) {
        initialized.current = true;      
        if (SessionStorageService.getItem("lastSearchEntidades") && !SessionStorageService.getItem("firstCallEntidade")) {
        const objToSearch = SessionStorageService.getItem("lastSearchEntidades") ?? '';
        consultarEntidades(objToSearch).then((data) => {
          SessionStorageService.setItem("resultadoEntidadePesquisa", JSON.stringify(data));
          setResultsEntidades();
        })
      } 
      else {
        setResultsEntidades();
    }
  }
    }, [])

    useEffect(() => {
      ReactGA.send({ hitType: "pageview", page: "/ResultadoEndidades" });
    }, []);


    const setResultsEntidades = () => {
      const results = JSON.parse(
      SessionStorageService.getItem('resultadoEntidadePesquisa') ?? ''
    )

    const idsJurisdicao: number[] = [];
    const ids: number[] = [];
    results.forEach((element: any) => {
      ids.push(element.id);
      if (element?.diEntidadeJurisdicoes && element?.diEntidadeJurisdicoes.length > 0) {
        idsJurisdicao.push(element?.diEntidadeJurisdicoes[0].id);
      }
    });
    const iframe: any = document.getElementById('iframeGeoPortal')
    const criterioEntidades = JSON.parse(SessionStorageService.getItem("criterioEntidades"));
    if (criterioEntidades == CRITERIO_SEDE) {

      
    iframe.contentWindow?.postMessage(
      { type: 'SiarlDefineExtraLayerTooltipColumns', value:
        { layer: ENTIDADE_POINT_NAME,  columns: colums.columns.filter((x: { show: any; }) => x.show).map((option: { field: any; title: any; }) => ({
     field: option.field,
     title: option.title
   })) } },
      '*'
    )

      SessionStorageService.setItem("criterioEntidades", JSON.stringify(CRITERIO_SEDE));
      iframe.contentWindow?.postMessage(
        { type: 'SiarlEntidadesSearch', value: {ids : ids, result: results}},
        '*'
      )
    }


    const formattedResults = results.map((entidade: any) => ({
      ...entidade,
    }))
    setEntidades(formattedResults);
    setEntidadesFinal(formattedResults.slice(paginacao.skip, paginacao.take + paginacao.skip))
    getVisibleColumns(keyPainelPrincipal, setColums)
    getVisibleColumns(keyPainelDocumentos, setColumsDocuments)
    getDocumentosByEntidades(ids).then(resultDocs => {
  const formattedDocs = resultDocs.map((doc: any) => ({
    ...doc,
    data_registo: doc.data_registo
      ? new Intl.DateTimeFormat('pt-PT', { dateStyle: 'short', timeStyle: 'short' }).format(new Date(doc.data_registo))
      : null,
  }));

  setDocumentos(formattedDocs);
});

  }

  useEffect(() => {
    const iframe: any = document.getElementById('iframeGeoPortal')
    const ids: number[] = []
    entidades.forEach((element: any) => {
      ids.push(element.id)
    })
    iframe.contentWindow?.postMessage(
      { type: 'SiarlEntidadesSearch', value: ids },
      '*'
    )
  }, [])
  
  const [clearMap] = useClearMap();
  const clearSearchResults = () => {
    clearMap(clearLayers["CLEAR_LAYERS_ENTIDADES"]);
    SessionStorageService.removeItem("entidade");
    SessionStorageService.removeItem('resultadoEntidadePesquisa')
    SessionStorageService.removeItem("lastSearchEntidades");
    postMessage({ type: 'resultadoEntidadePesquisaChange' }, '*')
    selectEntidadeResult(null)
    removeColumnsKeys(keyPainelDocumentos)
    removeColumnsKeys(keyPainelPrincipal)
  }

  const EntidadeCustomCell = (props: GridCellProps) => (
    <CustomGridCell
      {...props}
      onMouseEnter={handleRowMouseEnterById}
      onMouseLeave={handleRowMouseLeaveById}
    />
  )

  const handleRowMouseEnterById = (entidade: Record<string, any>) => {
    console.log(`#${entidade.id} - mostrar popover no mapa`)
    const iframe: any = document.getElementById('iframeGeoPortal')
    //iframe.contentWindow?.postMessage({ type: "SiarlOcorrenciasSearch", value: [ocorrencia.id] }, '*')
    if (entidade.id) {
      if (JSON.parse(SessionStorageService.getItem("criterioEntidades")) == CRITERIO_SEDE) {
        iframe.contentWindow?.postMessage(
          {
            type: 'SiarlEntidadesHighlight',
            value: [entidade.id],
          },
          '*'
        )
      }
    } else if (JSON.parse(SessionStorageService.getItem("criterioEntidades")) == CRITERIO_JURISDICAO) {
      if (entidade?.diEntidadeJurisdicoes && entidade?.diEntidadeJurisdicoes.length > 0) {
        iframe.contentWindow?.postMessage(
          {
            type: 'SiarlEntidadesApoioHighlight',
            value: [entidade?.diEntidadeJurisdicoes[0].id],
          },
          '*'
        )
      }
    }
  }

  const handleRowMouseLeaveById = (entidade: Record<string, unknown>) => {
    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage(
      {
        type: 'SiarlEntidadesHighlightRemove',
        value: [entidade.id],
      },
      '*'
    )
  }

  const handleLocationMouseEnterById = (
    entidade: Record<string, unknown>
  ) => {
    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage(
      {
        type: 'SiarlEntidadesHighlight',
        value: [entidade.id],
      },
      '*'
    )
  }

  const handleLocationMouseLeaveById = (
    entidade: Record<string, unknown>
  ) => {
    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage(
      {
        type: 'SiarlEntidadesHighlightRemove',
        value: [entidade.id],
      },
      '*'
    )
  }

  const handleInfoClickById = (entidadeLocal: Record<string, any>) => async () => {
    
    const id = entidadeLocal.entidade_id ?? entidadeLocal.id;
    const entidade = await getEntidade(id);

     if (!entidade) {
      postMessage({type: "infoMsg", value: { message: "Registo desativado" }}, "*");
      return;
    }

    const tecnico = await GetUserNameTecnico(entidade.utilizador_id);

    const locationObj: any = await fillLocation(entidade);

    const entidadeResult = {
      id: entidade.id,
      nome: entidade.nome ?? undefined,
      tecnicoRegisto: tecnico,
      sigla: entidade.codigo ?? undefined,
      morada: entidade.morada ?? undefined,
      localidade: entidade.localidade ?? undefined,
      tipo_entidade_id: entidade.tipo_entidade_id,
      tipoEntidade: entidade.tipoEntidade,
      email: entidade.oc_focal_point_email ?? undefined,
      url: entidade.url ?? undefined,
      jurisdicao: entidade.oc_notify_email_new_issue,
      telefone: entidade.telefone ?? undefined,
      email_grupo_ocorrencias: entidade.email_grupo_ocorrencias ?? undefined,
      codigoPostal: entidade.codigo_postal ?? undefined,
      tipoAcesso: entidade.tipoAcesso,
      tipo_acesso_id: entidade.tipo_acesso_id,
      dataHoraRegisto: entidade.data_registo ? moment.utc(entidade.data_registo).tz(CURRENT_TIMEZONE) : undefined,
      freguesia: locationObj?.freguesia ?? undefined,
      concelho: locationObj?.concelho ?? undefined,
      distrito: locationObj?.distrito ?? undefined,
      nuts1: locationObj?.nuts1 ?? undefined,
      nuts2: locationObj?.nuts2 ?? undefined,
      nuts3: locationObj?.nuts3 ?? undefined,
      diEntidadeJurisdicoes: entidade.diEntidadeJurisdicoes ?? undefined,
      lstFreguesiasJurisdicao: entidade.lstFreguesiasJurisdicao ?? undefined,
      lstConcelhosJurisdicao: entidade.lstConcelhosJurisdicao ?? undefined,
      lstDistritosJurisdicao: entidade.lstDistritosJurisdicao ?? undefined,
      lstNuts3Jurisdicao: entidade.lstNuts3Jurisdicao ?? undefined,
      lstNuts2Jurisdicao: entidade.lstNuts2Jurisdicao ?? undefined,
      lstNuts1Jurisdicao: entidade.lstNuts1Jurisdicao ?? undefined,
      lstMassaAguaJurisdicao : entidade?.lstMassaAguaJurisdicao ?? undefined,
      lstArhsJurisdicao: entidade?.lstArhsJurisdicao ?? undefined,
      lstCapitaniasJurisdicao: entidade?.lstCapitaniasJurisdicao ?? undefined,
      geom_imported: entidade?.geom_imported,
    }
    SessionStorageService.setItem('novaEntidade', 'false')
    sessionStorage.setItem('diGeomEdited', 'false')

    sessionStorage.setItem("jurisdicaoEntidade", entidade.oc_notify_email_new_issue ?? "")
    selectEntidadeResult(entidadeResult)
    setEntidadeSelected(entidadeResult);
    // sessionStorage.setItem("entidadeId", entidade.id);
    const iframe: any = document.getElementById('iframeGeoPortal')


    //iframe.contentWindow?.postMessage({ type: "SiarlEntidadesSearch", value: [entidade.id] }, '*')

    iframe.contentWindow?.postMessage({ type: "SiarlEntidadesCenter", value: [entidade.id] }, '*')

    const entidadeJuridicao: any = await getEntidadeJuridicao(entidade?.id);

    if (entidadeJuridicao) {
      const idToSend = [entidadeJuridicao.id];
      const iframe: any = document.getElementById('iframeGeoPortal')
      iframe.contentWindow?.postMessage({ type: "SiarlEntidadesApoioSearch", value: idToSend }, '*')
    }
    setShowResults(false)
    if (setShowEntidadeForm) setShowEntidadeForm(true)
  }

  const handlePageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent
    const take = event.page.take

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value)
    }

    restoreView();

    setPage({
      ...event.page,
      take,
    })
  }

  const handleLocationJurisdicaoClickById = (entidade: Record<string, any>) => async() => {
    restoreView();
    const entidadeFull = await getEntidade(entidade.id);
    const iframe: any = document.getElementById('iframeGeoPortal')
       if (entidadeFull?.diEntidadeJurisdicoes && entidadeFull?.diEntidadeJurisdicoes.length > 0) {
         const idToSend = [entidadeFull?.diEntidadeJurisdicoes[0].id];
         const iframe: any = document.getElementById('iframeGeoPortal')
         iframe.contentWindow?.postMessage({ type: "SiarlEntidadesApoioSearch", value: idToSend }, '*')
       }
    //}
  }

  const handleLocationClickById = (entidade: Record<string, any>) => () => {
    restoreView();
    const iframe: any = document.getElementById('iframeGeoPortal')
    // if (JSON.parse(SessionStorageService.getItem("criterioEntidades")) == CRITERIO_JURISDICAO) {
    //   if (entidade?.diEntidadeJurisdicoes && entidade?.diEntidadeJurisdicoes.length > 0) {
    //     const idToSend = [entidade?.diEntidadeJurisdicoes[0].id];
    //     const iframe: any = document.getElementById('iframeGeoPortal')
    //     iframe.contentWindow?.postMessage({ type: "SiarlEntidadesApoioSearch", value: idToSend }, '*')
    //   }
    // } else {
      const id = entidade.entidade_id ?? entidade.id;
      iframe.contentWindow?.postMessage(
        {
          type: 'SiarlEntidadesCenter',
          value: [id],
        },
        '*'
      )
    //}
  }
  const canSeeEntidadesEdit = hasPermission(PERMISSION_ENTIDADES_PERFIL_COMPLETO_EDICAO) || hasPermission(PERMISSION_ENTIDADES_PERFIL_TOTAL)
  const completoLeitura = hasPermission(PERMISSION_ENTIDADES_PERFIL_COMPLETO_LEITURA);

  const conditionalProps = canSeeEntidadesEdit || completoLeitura
  ? { 
    onInfoClick: handleInfoClickById
   } 
  : {};
  const CommandCell = (props: GridCellProps) => (
    <ResultadoEntidadeCommandGridCell
      {...props}
      onLocationClick={handleLocationClickById}
      onLocationMouseEnter={handleRowMouseEnterById}
      onLocationMouseLeave={handleRowMouseLeaveById}
      onLocationJurisdicaoClick={handleLocationJurisdicaoClickById}
     {...conditionalProps}
    />
  )

  const DocumentCommandCell = (props: GridCellProps) => (
    <ResultadoDocumentoCommandGridCell
    onLocationMouseEnter={function (documentos: Record<string, unknown>): void {
      console.log("n/a");
    } } onLocationMouseLeave={function (documentos: Record<string, unknown>): void {
      console.log("n/a");
    } } {...props}
    onLocationClick={handleLocationClickById}
    onInfoClick={handleInfoClickById}
    onDocumentPreviewClick={handleDocumentPreviewClickById}    />
  )

  const ColumnMenu = (dataState: any) => {
    return (
      <div>
      <GridColumnMenuSort {...dataState} />
      <GridColumnMenuFilter {...dataState} />
      <GridColumnMenuGroup {...dataState} />
    </div>)

  }

  const [documentos, setDocumentos] = useState<any>([]);
  const [selected, setSelected] = useState<number>(0);
  
  const REGISTOS = 0;
  const DOCUMENTOS = 1;
  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected)
    if (e.selected == REGISTOS) {
      setShowExportButtons(true)
    } else if (e.selected == DOCUMENTOS) {
      setShowExportButtons(false)
    }
  }

  const createDataState = (dataState: any) => {
    return {
      result: process(entidades.slice(0), dataState),
      dataState: dataState
    };
  };
  const initialState = createDataState({
    take: 8,
    skip: 0
  });
  const [result, setResult] = React.useState(initialState.result);
  const [dataState, setDataState] = React.useState({
    skip: 0,
    take: 20,
    sort: [],
    group: [],
  });

  const [dataStateDocumentos, setDataStateDocumentos] = React.useState({
    skip: 0,
    take: 20,
    sort: [],
    group: [],
  });

  const [dataResult, setDataResult] = React.useState(
    process(entidades, dataState)
  );

  const dataStateChange = (event: any) => {
    setDataResult(process(entidades, event.dataState));
    setDataState(event.dataState);

    const skipPag: PageState = { skip: event.dataState.skip, take: event.dataState.take}
setPaginacao({
  ...skipPag
})

  };


  const dataStateChangeDocumentos = (event: any) => {
    setDataResultDocumentos(process(documentos, event.dataState));
    setDataStateDocumentos(event.dataState);
  };

  const [dataResultDocumentos, setDataResultDocumentos] = React.useState(
    process(documentos, dataStateDocumentos)
  );

  const optionsImprimir = [
    {
      key: 'ExportarListaResultados',
      text: 'Resultados',
    },
  ]

  const optionsExportar = [
    {
      key: 'ExportarListaResultadosExcel',
      text: 'Excel',
    },
    // {
    //   key: 'ExportarListaResultadosPdf',
    //   text: 'PDF'
    // },
    {
      key: 'ExportarListaResultadosShapeFile',
      text: 'Shapefile'
    },
    {
      key: 'ExportarTodasFichas',
      text: 'Fichas',
    },
  ]

  const itemRender = (props: { item: any; itemIndex: number }) => {
    const isTitleItem = props.item.key === 'titulo';
    if (isTitleItem) {
      // Item de título personalizado
      return (
        <div className={styles.DropDownButtonTitulo}>
          <span>{props.item.text}</span>
        </div>
      );
    } else {
      // Demais itens
      return (
        <div className={styles.DropDownButtonItem}>
          <span>{props.item.text}</span>
        </div>
      );
    }
  };

  const [columsDocuments, setColumsDocuments] = useState<{ columns: {field?:string, title?:string, width?:number|string, show:boolean, columnMenu?:any, filter?:any}[] }>({
    columns: [
      { field: "id", title: "ID", filter: 'numeric', columnMenu: ColumnMenu, show: true ,width: 90},
      { field: "entidade_id", title: "Id Entidade", columnMenu: ColumnMenu, show: true ,width: 170},
      { field: "data_publicacao", title: "Data de Publicação", columnMenu: ColumnMenu, show: true ,  width: 270},
      { field: "tipo_recurso", title: "Tipo de Recurso", columnMenu: ColumnMenu, show: true ,  width: 180},
      { field: "titulo", title: "Título", columnMenu: ColumnMenu, show: true ,  width: 170},
      { field: "autores", title: "Autor", columnMenu: ColumnMenu, show: true ,  width: 170},
      { field: "entidade.nome", title: "Entidade", columnMenu: ColumnMenu, show: true ,  width: 200},
      { field: "primario", width: 180, title: "Primário", show: true },

    ]
  })

  const columnsInicio = {
    columns:[
      {field: "id", title: "ID", filter: 'numeric', columnMenu: ColumnMenu, show:true , width: 90},
      {field: "nome", title: "Designação", columnMenu: ColumnMenu , width: 200, show:true},
      {field: "tipo", title: "Tipo Entidade", show: true, width: 200, columnMenu: ColumnMenu },
      {field: "codigo_postal", title: "Código Postal", show: false, width: 190, columnMenu: ColumnMenu },
      {field: "localidade", title: "Localidade", show: true, width: 190, columnMenu: ColumnMenu },
      {field: "morada", title: "Morada", show: true, width: 200, columnMenu: ColumnMenu },
      { field: "url", width: 180, title: "URL", show: true },
    ]
  }
  const columnsOrdered = {columns: columnsInicio.columns.slice().sort((a: any, b: any) => a.title.localeCompare(b.title))}
  
  const [colums, setColums] =  useState<any>(() => {
    const storedValue = SessionStorageService.getItem('columnsEntidades');
    return storedValue ?? columnsOrdered;
  });
  const [columsGrid, setColumsGrid] =  useState<any>(() => {
    const storedValue = SessionStorageService.getItem('columnsEntidadesGrid');
    return storedValue ?? columnsInicio;
  });

   useEffect(() => {
    SessionStorageService.setItem("columnsEntidades", colums)

    updateColumnsGrid(colums, columsGrid, setColumsGrid);
  }, [colums])

  const  [showExportButtons, setShowExportButtons] = useState(true)

  const onItemClickExportarFichas = async () => {
    try {
  
    
      const relatorios = [];
  
      const results = JSON.parse(
        SessionStorageService.getItem('resultadoEntidadePesquisa') ?? ''
      );
    

      const idsEntidade = results.map((o: any) => o.id);
      if(idsEntidade.length  > 100){
      postMessage({ type: 'errorMsg', value: { message: "Não é possivel exportar mais de 100 fíchas" } }, '*')
      return false
      }  
  
      const entidades = await getEntidadesPorIds(idsEntidade);
      
        postMessage({ type: 'showLoader' }, '*');
      
        for (const entidadeId of idsEntidade) {
  
        const entidade = entidades.find((entidade: any) => entidade.id === entidadeId);
  
     
        const relatorio = {
          id: entidade?.id,
        dados: {
          //Registo
          'REGISTO' : '',
          'Técnico:': entidade?.utilizador?.name ?? '',

          //Identificacao
          'IDENTIFICAÇÃO' : '',
          'Nome:': entidade?.nome ?? '',
          'Sigla:': entidade?.codigo ?? '',
          'Url:': entidade?.url ?? '',
          'Email:': entidade?.on_focal_point_email ?? '',
          'Telefone:': entidade?.telefone ?? '',

          //Localizacao
          'LOCALIZAÇÃO' : '',
          'Nuts1:' : entidade?.apNuts3?.nuts2?.nuts1?.nome ?? '',
          'Nuts2:': entidade?.apNuts3?.nuts2?.nome ?? '',
          'Nuts3:' : entidade?.apNuts3?.nome  ?? '',
          'Concelho:' : entidade?.apFreguesia?.concelho?.nome ?? '',
          'Distrito:' : entidade?.apFreguesia?.concelho?.distrito?.nome ?? '',
          'Freguesia:' : entidade?.apFreguesia?.nome ?? '',
          'Morada:' : entidade?.morada ?? '',
          'Código postal:': entidade?.codigo_postal ?? '',
          'Localidade:': entidade?.localidade ?? '',
         
          //Entidade
          'ENTIDADE': '',
          'Tipo de entidade:' : entidade?.tipoEntidade?.designacao ?? '',
          'Tipo de acesso:' : entidade?.tipoAcesso?.designacao ?? ''
          
        },       
        img_mapa: "",
      };

        
        relatorios.push(relatorio);
    }
  
      const mergedPdfBase64 = await relatorioEntidadeMerge(relatorios);
      if (mergedPdfBase64) {
        const blob = b64toBlob(mergedPdfBase64, 'application/pdf');
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
      }
    } catch (error) {
      console.log(error);
      postMessage({ type: 'errorMsg', value: { left: '50%', message: "Verifique os campos obrigatórios." } }, '*');
    } finally {
      postMessage({ type: 'hideLoader' }, '*');
    }
  };


  const onItemClickExportar = async(event: any) => {
    if(event.item.key == "ExportarTodasFichas"){
      onItemClickExportarFichas();
    }

    if (event.item.key == 'ExportarListaResultadosExcel') {

      exportExcel();

    } else if (event.item.key == 'ExportarListaResultadosPdf') {

      exportPDFDownload();

    }
    else if (event.item.key == "ExportarListaResultadosShapeFile") {
      const results = JSON.parse(
        SessionStorageService.getItem('resultadoEntidadePesquisa') ?? ''
      )
  
        if (results) {
          const iframe: any = document.getElementById('iframeGeoPortal')
          const ids: number[] = []
          results.forEach((element: any) => {
            ids.push(element.id)
          })
  
          const columnsToExport = colums.columns.filter((x: { show: any; }) => x.show).map((x: { field: any; }) => x.field);
          const entidadesFiltred: any[] = [];
          entidades?.forEach((item: any) => {
            const filteredItem: any[] = [];
            colums.columns.filter((x: { show: any; }) => x.show).forEach((column: any) => {
              filteredItem.push({
                Key: column.field,
                Value: item[column.field]?.toString()
              });
            });
            entidadesFiltred.push(filteredItem);
        })
  
          const objToSend = {
            ids: ids,
            fields: columnsToExport,
            values: entidadesFiltred
          }
  
          const file: any = await getShapeFile(objToSend);
          const filePath = `siarl-lista-entidades-${format(new Date(), 'ddMMyyyHHmm')}.zip`;
  
         handleDownload(file, filePath);
    } 
  }

  };

  const documentosToPreview = documentos;
  
  let _pdfExport: any;
  const exportExcel = () => {
    _export.save();
  };

  let _export: any;
  const exportPDFDownload = () => {
     _pdfExport.save();
   };




   
   const openPdfNewTab = () => {
    return new Promise<void>((resolve, reject) => {
        
        postMessage({ type: "showLoader" }, "*");

        setTimeout(() => {
           const columnsToShow = colums.columns.filter((x: { show: any; }) => x.show);
            const dataToExport = entidades.map((item: any) => {
                const filteredItem: any = {};
                columnsToShow.forEach((column: any) => {
                    filteredItem[column.field] = item[column.field];
                });
                return filteredItem;
            });
            
            exportPDFWithMethod(columnsToShow, dataToExport, 8)
                .then((pdfData: any) => {
                    postMessage({ type: "hideLoader" }, "*");

                        const base64Data = pdfData.split(";base64,")[1];
                        console.log(base64Data);
                        const blob = b64toBlob(base64Data, 'application/pdf');
                        const blobUrl = URL.createObjectURL(blob);

                      
                        window.open(blobUrl, '_blank');
                        resolve();
                  
                })
                .catch(error => {
                    console.error('Error exporting PDF:', error);
                    reject(error);
                });
        }, 1000);
    });
};


  

  const onItemClickImprimir = async (event: any) => {
    openPdfNewTab();
  }


  const handleDocumentPreviewClickById = (documentosLocal: Record<string, any>) => async () => {

    try {

      postMessage({ type: "showLoader" }, "*");
      const documentos = await getDocumento(documentosLocal.id);

      setIdDoDocumento(documentosLocal.id);
      setUrlDoDocumento(documentos.url);
      setOpenForm(true);

    } catch (error) {

      handleGenericError(error, "Não foi possivel abrir o documento!")
      setOpenForm(false);

    } finally {

      postMessage({ type: "hideLoader" }, "*");

    }
  }

  const nextPhoto = async (e: any) => {

    try{

      postMessage({ type: "showLoader" }, "*");
      const nextIds = documentosToPreview
        .filter((doc: any) => doc.id < idDoDocumento && doc.url !== '')
        .map((doc: any) => doc.id);
  
      if (nextIds.length > 0) {
        const nextId = Math.max(...nextIds);
        console.log(`O próximo ID é ${nextId}`);
  
        const documento = await getDocumento(nextId);
  
        setIdDoDocumento(nextId.toString());
        setUrlDoDocumento(documento.url);

        const iframe: any = document.getElementById('iframeGeoPortal')
        const id = documento.entidade_id ?? documento.id;
        iframe.contentWindow?.postMessage(
          {
            type: 'SiarlEntidadesCenter',
            value: [id],
          },
          '*'
        )
  
      } else {
        console.log("Não há um próximo ID na lista.");
      }

    }catch(error){
      handleGenericError(error, "Não foi possivel abrir o documento!")

    }finally{

      postMessage({ type: "hideLoader" }, "*");

      e.preventDefault();
    }
   
  }

  const previousPhoto = async (e: any) => {

    try{

      postMessage({ type: "showLoader" }, "*");
      const previousIds = documentosToPreview
        .filter((doc: any) => doc.id > idDoDocumento && doc.url !== '')
        .map((doc: any) => doc.id);
  
      if (previousIds.length > 0) {
        const previousId = Math.min(...previousIds);
        console.log(`O anterior ID é ${previousId}`);
  
        const documento = await getDocumento(previousId);
  
        setIdDoDocumento(previousId.toString());
        setUrlDoDocumento(documento.url);

        const iframe: any = document.getElementById('iframeGeoPortal')
        const id = documento.entidade_id ?? documento.id;
        iframe.contentWindow?.postMessage(
          {
            type: 'SiarlEntidadesCenter',
            value: [id],
          },
          '*'
        )
      } else {
        console.log("Não há um anterior ID na lista.");
      }

    }catch(error){
      handleGenericError(error, "Não foi possivel abrir o documento!");

    }finally{

      postMessage({ type: "hideLoader" }, "*");

      e.preventDefault();
    }
       
  }

  useEffect(() => {

    const elemento: any = document.querySelector(".k-window-content.k-dialog-content");

    if (elemento) {
      elemento.style.padding = "0px";
    }

  }, [openForm]);

  const close = () => {
    setOpenForm(false);
  }

  useEffect(() => {
    SessionStorageService.setItem(keyPainelDocumentos, JSON.stringify(columsDocuments));
  }, [columsDocuments]);
  
  useEffect(() => {
    SessionStorageService.setItem(keyPainelPrincipal, JSON.stringify(colums));
    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage(
      { type: 'SiarlDefineExtraLayerTooltipColumns', value:{  layer: ENTIDADE_POINT_NAME,  columns: colums.columns.filter((x: { show: any; }) => x.show).map((option: { field: any; title: any; }) => ({
    field: option.field,
    title: option.title
  })) } },
      '*'
    )
  }, [colums]);
  
  useLayoutEffect(() => {

    const handleResize = () => {

      if (window.innerWidth <= telaMobile) {
        
        setIsMobile(true);
        ocultaFloatingMenu_e_Mapa();

      }else{

        setIsMobile(false);
        mostraFloatingMenu_e_Mapa();

      }

    };
  
    window.addEventListener('resize', handleResize);
  
    handleResize();
  
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []); 


  const onItemClickMais = (event: any) => {

    elementoClickMais(event);

    onItemClickExportar(event);

    onItemClickImprimir(event);

  };

  const optionsMais = [
    {
      key: 'titulo',
      text: 'Imprimir',
    },
    {
      key: 'imprimirFicha',
      text: 'Fichas',
      className: 'icon-siarl icon-imprimir btnIconRegistar'
    },
    {
      key: 'titulo',
      text: 'Exportar',
    },
    ...optionsExportar.map(option => ({
      ...option,
      className: 'icon-siarl icon-exportar btnIconRegistar',
    })),
  ]

  const registarNovoClick = () => {

    sessionStorage.setItem('diGeomEdited', 'false')
    SessionStorageService.setItem('novaEntidade', 'true')
    const loggedUser = JSON.parse(
      localStorage.getItem(AUTH_LOCALSTORAGE) ?? '{}'
    )
    selectEntidadeResult({ tecnicoRegisto: loggedUser?.user?.username })
    setEntidadeSelected({ tecnicoRegisto: loggedUser?.user?.username })
    postMessage({ type: 'form', value: 'registarEntidade' }, '*')
  }

  const openAjuda = () => {
    window.open(URL_AJUDA_ENTIDADES, "_blank");
  }

   const PageTemplate = (props: any) => (
    <div className="page-template">
       <div className="header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '10px', padding: '10px' }}>
      
       <div>
       <img style={{ width: '128px', height: 'auto', marginLeft: '2px' }} src={base64SiarlImage} alt="SIARL Logo" />
       </div>
       <div style={{ textAlign: 'right' }}>
         <span style={{ fontSize: '18px', color: '#1ba49c' }}>PESQUISA DE ENTIDADES</span>
       </div>
     </div>
     <div className="footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '10px' }}>
        
       <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
         <img style={{ width: '105px', marginBottom: '-25px' }} src={base64ApaImage} alt="APA Logo" />
         <img style={{ width: '280px', height: 'auto', marginBottom: '-25px' }} src={base64FooterImages} alt="Footer Image" />
       </div>
      
       <div style={{ flex: 1, textAlign: 'right', marginBottom: '-25px' }}>
        Data : {format(new Date(), "dd/MM/yyyy")} | Página {props.pageNum} de {props.totalPages}
       </div>
     </div>
   </div>
 );

  return (
    <div className={clsx(styles.base, isCurrentViewMaximized && commonStyles.maximizedBaseForm)}>
      <div className={styles.header}>
        <div>
          <div className={styles.nomeDoModulo}>Diretório de Entidades</div>
          <div className={styles.tituloDaPagina}>Resultados de pesquisa</div>
        </div>

        <div>

        {canSeeEntidadesEdit? 
          <Button onClick={registarNovoClick} className={styles.btnNovoRegisto}
          style={{ display: isMobile ? 'none' : '' }}
          id='novoRegisto' title='Nova entidade'>
            <span className="icon-siarl icon-registar btnIconRegistar"></span>{' '}
            &nbsp;{' '}
            Nova entidade
          </Button>
        :  ''}

          <CSVLink
            title="Imprimir resultados"
            id="print-results-entidades"
            separator={';'}
            data={entidades.map((entidade: any) => ({
              ...entidade,
            }))}
            filename={`siarl-entidades-${format(
              new Date(),
              'ddMMyyyHHmm'
            )}`}
            hidden
          ></CSVLink>

          {!isMobile && showExportButtons &&
               <VisualizadorColunas 
              columns={colums} 
              setColumns={setColums}
              styles={styles.btnEditar2} 
           />
          }
          {showExportButtons ? 
          <button className={styles.btnEditar2} onClick={exportPDFDownload} style={{ display: isMobile ? 'none' : '' }} id='imprimirFicha' title='Imprimir'>
            <span className="icon-siarl icon-imprimir"></span>
          </button>: ''}

          {!isMobile && showExportButtons &&
            <DropDownButton
              items={optionsExportar}
              className={styles.btnImprimir}
              style={{marginTop: '-4px'}}
              iconClass="icon-siarl icon-exportar"
              onItemClick={onItemClickExportar}
              fillMode={'flat'}
              title='Exportar'
              itemRender={itemRender}
            />
          }

          {isMobile && showExportButtons &&
            <DropDownButton
              items={optionsMais}
              className={styles.btnMais}
              iconClass="icon-siarl icon-mais"
              onItemClick={onItemClickMais}
              fillMode={'flat'}
              itemRender={itemRenderMais}
              title="Mais Opções"
            />
          }
                    
          <button onClick={openAjuda} className={styles.btnInfo} title="Obter Ajuda">
            <span className="icon-siarl icon-ajuda"></span>
          </button>

          <button className={styles.btnFechar} onClick={onCloseClick} title="Minimizar">
            <span className="icon-siarl icon-minimizar"></span>
          </button>

          {!isMobile &&
          <MaximizeButton className={styles.btnMaximizar} ></MaximizeButton>
          }
        </div>
      </div>

      <TabStrip selected={selected} onSelect={handleSelect} scrollable={isMobile}>
        <TabStripTab title="Entidades">
          <ExcelExport
            fileName='Resultado_Entidades'
            data={entidades}
            ref={(exporter) => {
              _export = exporter
            }}
          >
            <Grid
              className={styles.form}
              sortable={true}
              onDataStateChange={dataStateChange}
              data={dataResult.data.length > 0 ? dataResult : entidadesFinal.map((entidades: any) => ({
                ...entidades,  
        })).slice(paginacao.skip, paginacao.take + paginacao.skip)}
              {...dataState}
              pageable={pageble}
              skip={paginacao.skip}
              take={paginacao.take}
              total={entidades.length}
              //groupable={true}
              cells={{ data: EntidadeCustomCell }}
            >
              <GridColumn cell={CommandCell} width={68} />              
              {columsGrid?.columns?.map((column: { show: any; field: string | undefined; filter: any; columnMenu: React.ComponentType<GridColumnMenuProps> | undefined; width: string | number | undefined; title: string | undefined; }, i: React.Key | null | undefined) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} filter={column.filter} columnMenu={column.columnMenu}   width={column.width} title={column.title} />
              )
            );
          })}
              
            </Grid>
          </ExcelExport>

          <GridPDFExport
            fileName='Resultado_Entidades'
            ref={(element) => {
              _pdfExport = element
            }}
            
            paperSize="A4"
            margin={{ top: '3cm', right: '1cm', bottom: '2cm', left: '1cm' }}
            landscape={true}
            pageTemplate={PageTemplate} 
            repeatHeaders={true}
                   
          >
            {
              <Grid
                sortable={true}
                 data={entidades}                
                pageable={{
                  buttonCount: 5,
                  info: true,
                  type: 'numeric',
                  pageSizes: true,
                  previousNext: true,
                }}
                style={{ borderSpacing: '0' }} 
                //groupable={true}
              >
                {columsGrid?.columns?.map((column: any, i: any) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} filter={column.filter} width={column.width} title={column.title} columnMenu={column.columnMenu}
                headerCell={() => <div className="pdf-header">{column.title}</div>}
                cell={(props: any) => (
                  <td style={{ fontSize: '10px', wordBreak: 'break-word', padding: '5px', border: '1px solid #1ba49c' , lineHeight: '1.3' }}>
                    {props.dataItem[column.field]}
                  </td>
                )}
                />
              )
            );
          })}
              </Grid>
            }
          </GridPDFExport>
          
        </TabStripTab>

        <TabStripTab title="Documentos">
          <ExcelExport
            fileName='Resultado_Documentos_Entidade'
            data={documentos}
            ref={(exporter) => {
              _export = exporter
            }}
          >
            <Grid
              className={styles.form}
              sortable={true}
              onDataStateChange={dataStateChangeDocumentos}
              data={dataResultDocumentos.data.length > 0 ? dataResultDocumentos : documentos.map((documentos: any) => ({
                                          ...documentos,
                                          data_publicacao: documentos?.data_publicacao ? format(new Date(documentos.data_publicacao), 'dd/MM/yyyy') : undefined
                                        })).slice(page.skip, page.take + page.skip)
                                      }
              {...dataState}
              pageable={{
                buttonCount: 5,
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true,
              }}
              //groupable={true}
            >
              <GridColumn cell={DocumentCommandCell} width={86}  />
              {columsDocuments?.columns?.map((column, i) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} filter={column.filter} width={column.width} title={column.title} columnMenu={column.columnMenu} />
              )
            );
          })}
            </Grid>
          </ExcelExport>

          <GridPDFExport
            fileName='Resultado_Documentos_Entidades'
            ref={(element) => {
              _pdfExport = element
            }}
            margin="1cm"
          >
            {
              <Grid
                className={styles.form}
                sortable={true}
                onDataStateChange={dataStateChangeDocumentos}
                data={dataResultDocumentos.data.length > 0 ? dataResultDocumentos : documentos.map((documentos: any) => ({
                  ...documentos,
                  data_publicacao: documentos?.data_publicacao ? format(new Date(documentos.data_publicacao), 'dd/MM/yyyy') : undefined
                })).slice(page.skip, page.take + page.skip)
              }
                {...dataState}
                pageable={{
                  buttonCount: 5,
                  info: true,
                  type: 'numeric',
                  pageSizes: true,
                  previousNext: true,
                }}
                //groupable={true}
              >
                <GridColumn cell={DocumentCommandCell} width={86}  />
                <GridColumn
                  field="id"
                  title="Id"
                  filter={'numeric'}
                  columnMenu={ColumnMenu}
                />
                <GridColumn
                  field="data_registo"
                  title="Data"
                  columnMenu={ColumnMenu}
                />
                <GridColumn
                  field="titulo"
                  title="Titulo"
                  columnMenu={ColumnMenu}
                />
                <GridColumn
                  field="entidade"
                  width={'auto'}
                  title="Entidade"
                  columnMenu={ColumnMenu}
                />
              </Grid>
            }
          </GridPDFExport>
        </TabStripTab>
      </TabStrip>

      <div
        className={clsx(styles.footer, styles.justify_one_child, isCurrentViewMaximized && commonStyles.maximizedFooter)}
      >
        <Button className={styles.btnPesquisar} onClick={clearSearchResults} title='Nova Pesquisa'>
          <span className="icon-siarl icon-pesquisar"></span>
          <span className={styles.rotulo}>
            {' '}&nbsp;{' '}
            Nova pesquisa
          </span>
        </Button>
      </div>
      {openForm && (
        <Dialog
        className="ModalDocumentos"
          title={`Documento: ${idDoDocumento}`}
          onClose={close}
          style={{ zIndex: 999 }}
        >

            <ImagePreviewV2
              documentUrl={urlDoDocumento}
              next={(e: any) => nextPhoto(e)}
              previous={(e: any) => previousPhoto(e)}
            />

        </Dialog>
      )}
    </div>
  )
}

